var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.2796 38.0146C75.2796 58.9405 58.5895 75.9042 38.0011 75.9042C17.4128 75.9042 0.722656 58.9405 0.722656 38.0146C0.722656 17.0888 17.4128 0.125 38.0011 0.125C58.5895 0.125 75.2796 17.0888 75.2796 38.0146ZM6.22869 38.0146C6.22869 55.8497 20.4537 70.3079 38.0011 70.3079C55.5486 70.3079 69.7736 55.8497 69.7736 38.0146C69.7736 20.1795 55.5486 5.7213 38.0011 5.7213C20.4537 5.7213 6.22869 20.1795 6.22869 38.0146Z",
    fill: "#27AE60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5703 37.6049L33.3514 47.4266L52.9542 27.7832",
    stroke: "#27AE60",
    strokeWidth: 3.60759,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.3d48dbc80102d34e82a20e5dc62c9da0.svg";
export { ForwardRef as ReactComponent };